import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["swatch", "input"]

  connect() {
    const current = this.inputTarget.value
    if (current) {
      const deck = document.querySelector("[data-controller='deck']")
      if (deck && !deck.classList.contains(`theme-${current}`)) {
        deck.classList.add(`theme-${current}`)
      }
    }
  }

  select(event) {
    const key = event.currentTarget.dataset.themeKey
    const current = this.inputTarget.value

    // Clicking active theme reverts to default
    const newKey = current === key ? "" : key
    this.inputTarget.value = newKey

    // Update active swatch
    this.swatchTargets.forEach(s => {
      s.classList.toggle("theme-swatch--active", s.dataset.themeKey === newKey)
    })

    // Apply theme to deck container
    const deck = document.querySelector("[data-controller='deck']")
    if (!deck) return

    // Remove all theme classes
    deck.classList.forEach(cls => {
      if (cls.startsWith("theme-")) deck.classList.remove(cls)
    })

    if (newKey) deck.classList.add(`theme-${newKey}`)
  }
}
